<template>
    <div class="columns is-multiline">
        <div class="column">
            <div class="field has-addons lb-search-bar is-expanded">
                <p class="control has-icons-left lb-clean-input is-expanded">
                    <input
                        :placeholder="$t('search')"
                        class="input"
                        type="text"
                        @input="$emit('input', $event.target.value)"
                    />
                    <span class="icon is-small is-left">
                        <i class="mdi mdi-24px mdi-magnify"></i>
                    </span>
                </p>
                <div class="control mr-4 is-hidden-tablet">
                    <app-dropdown-filter
                        :options="buttons"
                        :filter.sync="selectedFilter"
                        :active="dropdownActive"
                        class="is-right lb-clean-input"
                        @click="dropdownActive = !dropdownActive"
                    />
                </div>
            </div>
        </div>
        <div :class="{ 'is-full-tablet': windowSize === 'tablet' }" class="column is-narrow">
            <app-buttons-filter
                :options="buttons"
                :filter.sync="selectedFilter"
                :class="{ 'is-pulled-right': windowSize !== 'tablet' }"
                class="is-hidden-mobile"
            />
        </div>
    </div>
</template>

<script>
import AppButtonsFilter from '@/components/AppButtonsFilter';
import AppDropdownFilter from '@/components/AppDropdownFilter';
export default {
    components: {
        AppButtonsFilter,
        AppDropdownFilter,
    },
    model: 'text',
    props: {
        text: {
            type: String,
            default: '',
        },
        filter: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            dropdownActive: false,
            selectedFilter: this.$t('Constants.FILTER_OPTION_ALL'),
            buttons: [this.$t('Constants.FILTER_OPTION_ALL'),this.$t('Constants.FILTER_OPTION_PROJECTS_INVITED'),this.$t('Constants.FILTER_OPTION_PROJECTS_PARTICIPATED')],
        };
    },
    computed: {
        windowSize() {
            return this.$mq;
        },
    },
    watch: {
        selectedFilter() {
            this.$emit('update:filter', this.selectedFilter);
        },
    },
};
</script>

<style scoped lang="sass"></style>
